import { Row, Col, Typography } from 'antd';
import { getSymbol } from './AudiometrySymbols';

const { Text } = Typography;

const SymbologyTable = ({ gridWithBackground, mode }) => {
  const isCompact = mode === 'compact';

  if (isCompact) {
    return (
      <div className={`symbology-grid-container ${gridWithBackground ? 'grid-with-background' : ''} compact-mode`}>
        <h2>Simbología</h2>
        <table className="symbology-html-table">
          <thead>
            <tr>
              <th className="label-cell empty-header" rowSpan={2} />
              <th colSpan={2} className="group-header">
                <Text strong>Umbrales Aéreos</Text>
              </th>
              <th colSpan={2} className="group-header">
                <Text strong>Umbrales Óseos</Text>
              </th>
            </tr>
            <tr>
              <th className="ear-header right-ear-text">OD</th>
              <th className="ear-header left-ear-text">OI</th>
              <th className="ear-header right-ear-text">OD</th>
              <th className="ear-header left-ear-text">OI</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="label-cell">
                <Text strong>Conducción</Text>
              </td>
              <td className="symbol-cell">{getSymbol('AC_RE')}</td>
              <td className="symbol-cell">{getSymbol('AC_LE')}</td>
              <td className="symbol-cell">{getSymbol('BC_RE')}</td>
              <td className="symbol-cell">{getSymbol('BC_LE')}</td>
            </tr>
            <tr>
              <td className="label-cell">
                <Text strong>Enmascaramiento</Text>
              </td>
              <td className="symbol-cell">{getSymbol('AC_RE_MASKING')}</td>
              <td className="symbol-cell">{getSymbol('AC_LE_MASKING')}</td>
              <td className="symbol-cell">{getSymbol('BC_RE_MASKING')}</td>
              <td className="symbol-cell">{getSymbol('BC_LE_MASKING')}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className={`symbology-grid-container ${gridWithBackground ? 'grid-with-background' : ''}`}>
      <h2>Simbología</h2>
      <table className="symbology-html-table">
        <thead>
          <tr>
            <th className="group-header" width="35%">
              <Text strong>Umbrales Aéreos</Text>
            </th>
            <th className="ear-header right-ear-text" width="7.5%">OD</th>
            <th className="ear-header left-ear-text" width="7.5%">OI</th>
            <th className="group-header" width="35%">
              <Text strong>Umbrales Óseos</Text>
            </th>
            <th className="ear-header right-ear-text" width="7.5%">OD</th>
            <th className="ear-header left-ear-text" width="7.5%">OI</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="label-cell">
              <Text strong>Conducción</Text>
            </td>
            <td className="symbol-cell">{getSymbol('AC_RE')}</td>
            <td className="symbol-cell">{getSymbol('AC_LE')}</td>
            <td className="label-cell">
              <Text strong>Conducción</Text>
            </td>
            <td className="symbol-cell">{getSymbol('BC_RE')}</td>
            <td className="symbol-cell">{getSymbol('BC_LE')}</td>
          </tr>
          <tr>
            <td className="label-cell">
              <Text strong>Enmascaramiento</Text>
            </td>
            <td className="symbol-cell">{getSymbol('AC_RE_MASKING')}</td>
            <td className="symbol-cell">{getSymbol('AC_LE_MASKING')}</td>
            <td className="label-cell">
              <Text strong>Enmascaramiento</Text>
            </td>
            <td className="symbol-cell">{getSymbol('BC_RE_MASKING')}</td>
            <td className="symbol-cell">{getSymbol('BC_LE_MASKING')}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SymbologyTable;
